<template>
  <div class="big">
    <DocMsg
      :isFlag="doc_msg"
      :doctorId="doctorId"
    ></DocMsg>
    <div class="page_title">医生账户列表</div>
    <div style="padding: 20px">
      <div class="container">
        <div style="text-align: left; margin-bottom: 10px">
          <span>医生姓名</span>
          <el-input
            v-model="doctor_name"
            style="width: 160px; margin: 0 20px 0 10px"
            @input="search"
            clearable
          ></el-input>
          <span>医生手机</span>
          <el-input
            v-model="phone"
            style="width: 160px; margin: 0 10px"
            @input="search"
            clearable
          ></el-input>
          <span>医院</span>
          <el-input
            v-model="hospital"
            style="width: 160px; margin: 0 10px"
            @input="search"
            clearable
          ></el-input>
          <el-button
            plain
            style="margin-left: 10px; background: #ececec"
            size="medium"
            @click="search"
          >查询</el-button>
        </div>
        <div class="searchbox">
          <div class="item">
            <span>医生人数：</span>
            <span>{{ num_data.doctor_total }}人</span>
          </div>
          <div class="item">
            <span>税前总计：</span>
            <span>{{ num_data.sa_money_total }}</span>
          </div>
          <div class="item">
            <span>扣缴税额：</span>
            <span>{{ num_data.taxation_money_total }}</span>
          </div>
          <div class="item">
            <span>税后总计：</span>
            <span>{{ num_data.pay_money_total }}</span>
          </div>
          <div class="item">
            <span>待结算金额：</span>
            <span>{{ num_data.wait_total }}</span>
          </div>
          <div class="item">
            <span>平台补贴/补扣：</span>
            <span>{{ num_data.subsidy_total }}</span>
          </div>
          <div class="item">
            <span>账户余额：</span>
            <span>{{ num_data.doctor_total_price }}</span>
          </div>
          <div class="item">
            <span>提现总计：</span>
            <span>{{ num_data.withdraw_total }}</span>
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            @sort-change="changeOrder"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              prop="doctor_name"
              label="医生信息"
            >
              <template slot-scope="scope">
                <div>
                  <span
                    @click="showDocMsg(scope.row.doctor_id)"
                    style="cursor:pointer"
                  >{{ scope.row.doctor_name }}</span>
                  <span
                    v-if="scope.row.sex == 1"
                    style="margin-left: 16px"
                  >男</span>
                  <span
                    v-if="scope.row.sex == 2"
                    style="margin-left: 16px"
                  >女</span>
                </div>
                <div>
                  <span>{{ scope.row.phone }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              prop="hospital"
              label="医院名称"
            ></el-table-column>
            <el-table-column
              prop="sa_money"
              label="税前总收入"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="taxation_money"
              label="扣缴税额"
            ></el-table-column>
            <el-table-column
              prop="pay_money"
              label="税后总收入"
            ></el-table-column>
            <el-table-column
              prop="wait_money"
              label="待结算金额（未入账）"
            ></el-table-column>
            <el-table-column
              prop="bk_price"
              label="平台补扣/补贴"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="t_price"
              label="账户余额"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="settle_money"
              label="可提现余额"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="no_settle_money"
              label="不可提现余额"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="y_pay_money"
              label="总提现"
            ></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="transferAccounts(scope.row.doctor_id)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('510')
                      : false
                  "
                >转账</el-button>
                <el-button
                  type="text"
                  @click="Allowance(scope.row)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('511')
                      : false
                  "
                >补贴/补扣</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 平台补贴/补扣 -->
    <el-dialog
      title="平台补贴/补扣"
      :visible.sync="allowance"
      width="400px"
      class="other"
      :close-on-click-modal="false"
    >
      <el-dialog
        width="300px"
        title="转入提示"
        :visible.sync="innerallowance"
        append-to-body
      >
        <div class="dialogbox">
          <div>
            <span>{{ allowance_data.doctor_name }}</span>
            <span
              style="margin: 0 20px"
              v-if="allowance_data.sex == 1"
            >男</span>
            <span
              style="margin: 0 20px"
              v-if="allowance_data.sex == 2"
            >女</span>
            <span>{{ allowance_data.phone }}</span>
          </div>
          <div
            v-if="allowance_data.is_cashout_proportion == 1"
            style="margin-top: 20px"
          >
            <el-radio
              v-model="account_type"
              :label="2"
            >可提现余额</el-radio>
            <el-radio
              v-model="account_type"
              :label="3"
            >不可提现余额</el-radio>
          </div>
          <div style="margin-top: 10px">
            <span>确认{{ pay_money > 0 ? "补贴" : "补扣" }}</span>
            <span
              :style="pay_money > 0 ? 'color:#FF0000' : 'color:#669961'"
              style="font-weight: 700"
            >{{ pay_money > 0 ? "+" + pay_money : pay_money }}</span>
            <span v-if="account_type == 1">至账户余额？</span>
            <span v-if="account_type == 2">至可提现余额？</span>
            <span v-if="account_type == 3">至不可提现余额？</span>
          </div>
          <div style="text-align: center; margin-top: 20px">
            <el-button
              type="primary"
              size="mini"
              @click="confirmAllowance"
            >确认</el-button>
            <el-button
              plain
              size="mini"
              @click="innerallowance = false"
            >取消</el-button>
          </div>
        </div>
      </el-dialog>
      <div class="dialogbox">
        <div style="padding-left: 6px">
          <span>{{ allowance_data.doctor_name }}</span>
          <span
            style="margin: 0 20px"
            v-if="allowance_data.sex == 1"
          >男</span>
          <span
            style="margin: 0 20px"
            v-if="allowance_data.sex == 2"
          >女</span>
          <span>{{ allowance_data.phone }}</span>
        </div>
        <div class="userinfo">
          <div class="flex_between">
            <span>税前总收入</span>
            <span>{{ allowance_data.sa_money }}</span>
          </div>
          <div
            class="flex_between"
            style="margin: 8px 0"
          >
            <span>税后总收入</span>
            <span>{{ allowance_data.pay_money }}</span>
          </div>
          <div
            class="flex_between"
            style="margin: 8px 0"
          >
            <span>累计扣缴税额</span>
            <span>{{ allowance_data.taxation_money }}</span>
          </div>
          <div class="flex_between">
            <span>累计平台补贴/补扣</span>
            <span>{{ allowance_data.bk_price }}</span>
          </div>
        </div>
        <div>
          <span>平台补贴/补扣</span>
          <el-input-number
            v-model="pay_money"
            :min="-99999.99"
            :max="99999.99"
            style="width: 200px; margin-left: 10px"
            :controls="false"
          ></el-input-number>
        </div>
        <div style="color: #fd8217; margin: 4px 0 20px">
          注：输入正数为补贴，负数为补扣
        </div>
        <div style="text-align: center">
          <el-button
            type="primary"
            size="medium"
            @click="showinner"
          >确认</el-button>
          <el-button
            plain
            size="medium"
            @click="allowance = false"
          >取消</el-button>
        </div>
      </div>
    </el-dialog>
    <!--绿色通道转账-->
    <el-dialog
      title="绿色通道转账"
      :visible.sync="transfer"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="dialogbox">
        <div style="font-weight: 700">请确认医生账户信息及转账信息</div>
        <div class="userinfo">
          <div style="padding-left: 20px; font-weight: 700">
            <span>{{ transfer_data.doctor_name }}</span>
            <span
              style="margin: 0 20px"
              v-if="transfer_data.sex == 1"
            >男</span>
            <span
              style="margin: 0 20px"
              v-if="transfer_data.sex == 2"
            >女</span>
            <span
              style="margin: 0 20px"
              v-if="transfer_data.sex == 0"
            >未知</span>
            <span>{{ transfer_data.phone }}</span>
          </div>
          <div style="margin: 10px 0">
            <span class="title">银行卡号</span>
            <el-input
              v-model="transfer_data.bank_account"
              style="width: 340px"
            ></el-input>
          </div>
          <div style="margin: 10px 0">
            <span class="title">开户行</span>
            <el-select
              v-model="transfer_data.bank_code"
              placeholder="请选择"
              style="width: 340px"
            >
              <el-option
                v-for="item in bankList"
                :key="item.bank_code"
                :label="item.bank_name"
                :value="item.bank_code"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <span class="title">支行信息</span>
            <el-input
              v-model="transfer_data.bank_branch"
              style="width: 340px"
            ></el-input>
          </div>
        </div>
        <div style="font-weight: 700">转出类型</div>
        <div class="userinfo">
          <!-- 开启提现比例 -->
          <div v-if="transfer_data.is_cashout_proportion == 1">
            <div>
              <el-radio
                v-model="account_type"
                :label="2"
              >可提现余额</el-radio>
              <el-input-number
                v-model="transfer_data.pay_money_yes"
                :min="1"
                :max="Number(transfer_data.settle_money)"
                style="width: 295px"
                :controls="false"
                :disabled="account_type == 3"
              ></el-input-number>
            </div>
            <div style="padding-left: 125px; color: #fd8217; margin-bottom: 10px">
              可用余额：¥{{ transfer_data.settle_money }}
            </div>
            <div>
              <el-radio
                v-model="account_type"
                :label="3"
              >不可提现余额</el-radio>
              <el-input-number
                v-model="transfer_data.pay_money_no"
                :min="1"
                :max="Number(transfer_data.no_settle_money)"
                style="width: 295px; margin-left: -13px"
                :disabled="account_type == 2"
                :controls="false"
              ></el-input-number>
            </div>
            <div style="padding-left: 125px; color: #fd8217">
              可用余额：¥{{ transfer_data.no_settle_money }}
            </div>
          </div>
          <!-- 不开启比例 -->
          <div v-if="transfer_data.is_cashout_proportion == 0">
            <span class="title">账户余额</span>
            <el-input-number
              v-model="transfer_data.pay_money_yes"
              :min="1"
              :max="Number(transfer_data.settle_money)"
              style="width: 340px"
              :controls="false"
            ></el-input-number>
            <div style="padding-left: 80px; color: #fd8217; margin-top: 8px">
              可用余额：¥{{ transfer_data.settle_money }}
            </div>
          </div>

          <div>
            <div style="margin: 20px 0 10px">
              <span class="title">转账手续费</span>
              <span style="margin-left: 20px">{{ service_charge }}</span>
            </div>
            <div>
              <span class="title">实际到账</span>
              <span style="margin-left: 20px">{{ actual_arrival }}</span>
            </div>
          </div>
        </div>
        <div style="text-align: center">
          <el-button
            type="primary"
            size="medium"
            @click="confirmTransfer"
          >确认</el-button>
          <el-button
            plain
            size="medium"
            @click="transfer = false"
          >取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import _ from 'lodash';
import DocMsg from '../../../components/common/DocMsg.vue';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      num_data: {},
      doctor_name: '',
      phone: '',
      hospital: '',
      transfer: false,
      transfer_data: {},
      bankList: [],
      radio: '',
      allowance: false,
      innerallowance: false,
      allowance_data: {},
      pay_money: undefined,
      account_type: '',
      doc_msg: false,
      doctorId: ''
    };
  },
  components: {
    DocMsg
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    //手续费
    service_charge() {
      if (
        (this.account_type == 1 || this.account_type == 2) &&
        this.transfer_data.pay_money_yes
      ) {
        this.transfer_data.pay_money_no = undefined;
        let charge = (this.transfer_data.pay_money_yes * 0.001).toFixed(2);
        if (charge && charge < 1) {
          return 1;
        } else {
          return charge;
        }
      } else if (this.account_type == 3 && this.transfer_data.pay_money_no) {
        this.transfer_data.pay_money_yes = undefined;
        let charge_no = (this.transfer_data.pay_money_no * 0.001).toFixed(2);
        if (charge_no && charge_no < 1) {
          return 1;
        } else {
          return charge_no;
        }
      } else {
        return 0;
      }
    },
    actual_arrival() {
      if (this.service_charge) {
        if (this.account_type == 1 || this.account_type == 2) {
          return this.transfer_data.pay_money_yes - this.service_charge;
        } else {
          return this.transfer_data.pay_money_no - this.service_charge;
        }
      } else {
        return 0;
      }
    }
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_name: this.doctor_name,
        phone: this.phone,
        hospital: this.hospital,
        orderby: this.orderby
      };
      this.axios
        .post('platform/Cost/getDoctorAccountList', data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list;
            this.num_data = _.omit(res.data, ['list']);
            this.totalNum = res.data.total;
          }
        });
    },
    //更改顺序
    changeOrder(value) {
      let order = value.order;
      let prop = value.prop;
      //升序
      if (order == 'ascending') {
        if (prop == 'sa_money') {
          this.orderby = 1;
        } else if (prop == 'bk_price') {
          this.orderby = 3;
        } else if (prop == 't_price') {
          this.orderby = 5;
        } else if (prop == 'settle_money') {
          this.orderby = 7;
        } else if (prop == 'no_settle_money') {
          this.orderby = 9;
        }
      }
      //降序
      if (order == 'descending') {
        if (prop == 'sa_money') {
          this.orderby = 2;
        } else if (prop == 'bk_price') {
          this.orderby = 4;
        } else if (prop == 't_price') {
          this.orderby = 6;
        } else if (prop == 'settle_money') {
          this.orderby = 8;
        } else if (prop == 'no_settle_money') {
          this.orderby = 10;
        }
      }
      if (!order) {
        this.orderby = 0;
      }
      this.getList();
    },
    //获取银行列表
    getBankList() {
      this.axios.post('platform/Cost/getBankList').then((res) => {
        if (res.code == 0) {
          this.bankList = res.data.list;
        }
      });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    handleSelectionChangetable(val) {
      this.Selection = val;
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //转账弹窗
    transferAccounts(doctor_id) {
      this.axios
        .post('platform/Cost/getDoctorBankDetails', { doctor_id })
        .then((res) => {
          if (res.code == 0) {
            this.transfer_data = res.data.info;
            if (this.transfer_data.is_cashout_proportion == 0) {
              this.account_type = 1;
            } else {
              this.account_type = 2;
            }
            this.transfer = true;
          }
        });
    },
    //确认转账
    confirmTransfer() {
      if (this.account_type == 1 || this.account_type == 2) {
        if (!this.transfer_data.pay_money_yes) {
          this.$message.error('请完善转账信息');
          return false;
        }
      } else {
        if (!this.transfer_data.pay_money_no) {
          this.$message.error('请完善转账信息');
          return false;
        }
      }
      this.transfer_data.pay_money =
        this.account_type == 3
          ? this.transfer_data.pay_money_no
          : this.transfer_data.pay_money_yes;
      let data = {};
      data = _.pick(this.transfer_data, [
        'doctor_id',
        'pay_money',
        'bank_account',
        'bank_code',
        'bank_name',
        'account_name',
        'bank_branch'
      ]);
      data.account_type = this.account_type;
      this.axios
        .post('platform/Cost/greenTransferAccounts', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('转账已确认！');
            this.transfer = false;
            this.getList();
          }
        });
    },
    //补贴补扣弹窗
    Allowance(row) {
      this.allowance_data = row;
      this.allowance_data.money = 0;
      if (row.is_cashout_proportion == 0) {
        this.account_type = 1;
      } else {
        this.account_type = 2;
      }
      this.pay_money = undefined;
      this.allowance = true;
    },
    //补贴补扣小弹窗
    showinner() {
      if (!this.pay_money) {
        this.$message.error('请完善补贴/补扣信息');
        return false;
      }
      this.innerallowance = true;
    },
    //确认补贴补扣
    confirmAllowance() {
      let data = {
        doctor_id: this.allowance_data.doctor_id,
        pay_money: this.pay_money > 0 ? '+' + this.pay_money : this.pay_money,
        account_type: this.account_type
      };
      this.axios
        .post('platform/Cost/platformSubsidyPatch', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('转入成功！');
            this.innerallowance = false;
            this.allowance = false;
            this.getList();
          }
        });
    },
    //医生提成设置弹窗
    showDialog() {
      let loading = this.$loading();
      let data = {
        doctor_id: this.doctor_id,
        page: 1,
        pageNumber: 100
      };
      this.axios
        .post('platform/doctor/getHospitalDoctorList', data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData2 = res.data.list.map((item) => {
              item.edit = false;
              return item;
            });
            this.dialog = true;
            loading.close();
          }
        });
    }
  },

  created() {
    this.getList();
    this.getBankList();
  },
  activated() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  border-radius: 5px;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  .item {
    margin-right: 24px;
    color: #f6831f;
  }
}
.other {
  .el-checkbox {
    width: 130px;
    margin-bottom: 10px;
  }
}
.dialogbox {
  padding: 20px;
  text-align: left;
  .userinfo {
    background: #f2f1f0;
    padding: 10px;
    margin: 12px 0;
    .title {
      display: inline-block;
      width: 70px;
      text-align: right;
      margin-right: 10px;
    }
  }
}
</style>


